// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E_D1C","content":"styles_content__kuSmx","tableWrap":"styles_tableWrap__13zRv"};